import React, { PureComponent } from "react";
import styled from "styled-components";
import members from "../../data/memberInformation";
import { color, themeType, typo } from "../../styles/style";
import ImgAtom from "../atoms/ImgAtom";
import TextAtom from "../atoms/TextAtom";

const MemberCardFlexBoxOuter = styled.div`
  display: flex;
  flex-direction: ${(props) => props.flexDirection || "column"};
  justify-content: ${(props) => props.justifyContent || "center"};
  height: ${(props) => props.height || "100%"};
  width: ${(props) => props.width || "100%"};
  margin: ${(props) => props.margin || "0px 0px"};
  width: 28%;
  height: auto;
  background: white;
  align-items: center;
  margin: 0 0 35px 0;
  flex-wrap: wrap;
  ${({ theme }) => theme.media.tablet`
    width: 39%;
    `}
  ${({ theme }) => theme.media.mobile`
    width: 80%;
    `}
`;
const MemberCardFlexBox = styled.div`
  display: flex;
  flex-direction: ${(props) => props.flexDirection || "column"};
  justify-content: ${(props) => props.justifyContent || "center"};
  height: ${(props) => props.height || "100%"};
  width: ${(props) => props.width || "100%"};
  margin: ${(props) => props.margin || "0px 0px 35px 0px"};
  padding: ${(props) => props.padding || "0 0"};
  background: ${(props) => props.background};
  align-items: ${(props) => props.alignItem};
  border-radius: ${(props) => props.borderRadius};
  height: auto;
  border-radius: 10px;
  align-items: center;
  flex-wrap: wrap;

  ${({ theme }) => theme.media.tablet`
    `}
  ${({ theme }) => theme.media.mobile`
  justify-content: center;
    `}
`;

const MembersBoxOuter = styled.div`
display: flex;
flex-direction: ${(props) => props.flexDirection || "row"};
justify-content: ${(props) => props.justifyContent || "center"};
height: ${(props) => props.height || "100%"};
width: ${(props) => props.width || "100%"};
margin: ${(props) => props.margin || "0px 0px"};
padding: ${(props) => props.padding || "0 0"};
background: ${(props) => props.background};
align-items: ${(props) => props.alignItem};
border-radius: ${(props) => props.borderRadius};
flex-wrap: wrap;
`;

export class MemberInformationMolecule extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <MemberCardFlexBoxOuter>
        <MemberCardFlexBox background={this.props.house} >
          <ImgAtom
            src={this.props.src}
            onMouseOver={this.props.onMouseOver}
            onMouseOut={this.props.onMouseOut}
          />
        </MemberCardFlexBox>
        <MemberCardFlexBox margin="0 0 10px 0">
          <TextAtom
            text={this.props.name}
            typo={this.props.nameTypo}
            color={this.props.nameColor}
          />
        </MemberCardFlexBox>
        <TextAtom
          text={this.props.roleText}
          typo={this.props.roleTypo}
          color={this.props.roleColor}
        />
      </MemberCardFlexBoxOuter>
    );
  }
}

class MemberInformationMolecules extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }
  memberCard = (members) => {
    return members.map((member,index) => {
      return (
        <MemberInformationMolecule
          onMouseOver={member.hover}
          onMouseOut={member.unhover}
          house={member.color}
          src={member.image}
          name={member.name}
          nameTypo={typo.body.b1}
          nameColor={color(themeType.dark).text.primary}
          roleText={member.role}
          roleTypo={typo.body.b2}
          roleColor={color(themeType.dark).text.placeholder}
          key={index}
        />
      );
    });
  };

  render() {
    const membersCard = this.memberCard(members);
    return (
      <MembersBoxOuter justifyContent="center" id={this.props.id}>
        <MemberCardFlexBox
          width="80%"
          flexDirection="row"
          justifyContent="space-between"
        >
          {membersCard}
        </MemberCardFlexBox>
      </MembersBoxOuter>
    );
  }
}


export default MemberInformationMolecules;
